const School = ['Scenes_02.png','school01.png','school02.png','school03.png','school04.png','school05.png','school06.png'];
export default School